import {
  ExcelReportsUrls,
  ReportParams,
} from '../services/api/reportsServices';
import { ExportReportFilters, ReportSource } from './reports';

export abstract class Report {
  public filterErrorMessage = '';

  constructor(
    public apiUrl: string,
    protected filters: ExportReportFilters,
    protected isUserAdmin: boolean,
    protected isManagerFilterMandatory?: boolean
  ) {}

  isValid(): boolean {
    if (!this.filters) {
      this.filterErrorMessage = 'Filters not set!';

      return false;
    }

    if (
      !this.isUserAdmin &&
      !this.filters.managerId &&
      this.isManagerFilterMandatory
    ) {
      this.filterErrorMessage = 'Manager filter not set!';

      return false;
    }

    return true;
  }

  buildPayload(): ReportParams {
    return {
      startDate: this.filters.startDate,
      endDate: this.filters.endDate,
      employeeIds: this.filters.employeeId
        ? [this.filters.employeeId as string]
        : [],
      showHierarchy: this.filters.showHierarchy,
    };
  }
}

export class SynthesisReport extends Report {
  constructor(filters: ExportReportFilters, isUserAdmin: boolean) {
    super(ExcelReportsUrls.SYNTHESIS, filters, isUserAdmin);
  }

  buildPayload(): ReportParams {
    return {
      ...super.buildPayload(),
      ...(this.filters.projectId && { projectIds: [this.filters.projectId] }),
      ...(this.filters.managerId && { managerId: this.filters.managerId }),
      ...(this.filters.reportSource && this.filters.reportSource === ReportSource.PROJECT && this.filters.towerId && { towerId: this.filters.towerId }),
      ...(this.filters.reportSource && {
        reportSource: this.filters.reportSource,
      }),
      ...(this.filters.includeInactive && {
        includeInactive: this.filters.includeInactive,
      }),
      ...(this.filters.includeDeleted && {
        includeDeleted: this.filters.includeDeleted,
      }),
    };
  }
}

export class ActivityDetailedReport extends Report {
  constructor(
    filters: ExportReportFilters,
    isUserAdmin: boolean,
    isManagerFilterMandatory = false
  ) {
    super(
      ExcelReportsUrls.DETAILS,
      filters,
      isUserAdmin,
      isManagerFilterMandatory
    );
  }

  buildPayload(): ReportParams {
    return {
      ...super.buildPayload(),
      ...(this.filters.projectId && { projectIds: [this.filters.projectId] }),
      ...(this.filters.managerId && { managerId: this.filters.managerId }),
      ...(this.filters.reportSource && this.filters.reportSource === ReportSource.PROJECT && this.filters.towerId && { towerId: this.filters.towerId }),
      ...(this.filters.reportSource && {
        reportSource: this.filters.reportSource,
      }),
      ...(this.filters.includeInactive && {
        includeInactive: this.filters.includeInactive,
      }),
      ...(this.filters.includeDeleted && {
        includeDeleted: this.filters.includeDeleted,
      }),
    };
  }
}

export class ProjectActivityReport extends Report {
  constructor(filters: ExportReportFilters, isUserAdmin: boolean) {
    super(ExcelReportsUrls.PROJECT_ACTIVITY, filters, isUserAdmin);
  }

  isValid(): boolean {
    const isValid = super.isValid();

    if (isValid && !this.filters.projectId) {
      this.filterErrorMessage = 'Project filter not set!';

      return false;
    }

    return true;
  }

  buildPayload(): ReportParams {
    return {
      ...super.buildPayload(),
      ...(this.filters.projectId && { projectIds: [this.filters.projectId] }),
      ...(this.isUserAdmin && { managerId: this.filters.managerId }),
    };
  }
}

export class InterdepReport extends Report {
  constructor(filters: ExportReportFilters, isUserAdmin: boolean) {
    super(ExcelReportsUrls.INTERDEP, filters, isUserAdmin);
  }

  buildPayload(): ReportParams {
    const payload = { ...super.buildPayload() };

    if (payload && payload.employeeIds) {
      delete payload.employeeIds;
    }

    return {
      ...payload,
      ...(this.filters.employeeId && { employeeId: this.filters.employeeId }),
      ...(this.filters.managerId && { managerId: this.filters.managerId }),
      ...(this.filters.includeInactive && {
        includeInactive: this.filters.includeInactive,
      }),
      ...(this.filters.includeDeleted && {
        includeDeleted: this.filters.includeDeleted,
      }),
    };
  }
}
